export default "__VITE_ASSET__Djl$OsgK__"